module.exports = __webpack_public_path__ + "static/img/1566504801a7afbf1536eed8a789b78.1989304.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1566504801a7afbf1536eed8a789b78.jpg
// module id = kmeC
// module chunks = 1